import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentHolderComponent } from '../../components/component-holder/component-holder';

let formComponents: any = [
  { 'compName': 'ComponentHolderComponent', 'comp':  ComponentHolderComponent},
];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule
  ]
})

@Injectable()
export class componentHolderService {
  constructor() { }

  getComponents() {
    return formComponents;
  }

  getComponent(name) {
    let components = formComponents;
    for (let i = 0; i < components.length; i++) {
      let item = components[i];
      if (item.compName === name) {
        return item['comp'];
      }
    };
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/providers/component-holder.service/component-holder.service.ts